export class TransactionStatusValueConverter {
    toView(value:number): string {
        switch(value) {
            case 0:
                return "Kiosk";
            case 1:
                return "Client";
            case 2:
                return "Unprocessed";
            case 3:
                return "Approved";
            case 4:
                return "Declined";
            case 5:
                return "Faulted";
            case 6:
                return "Refunded";
            case 7:
                return "Refund Failed";
            case 8:
                return "Removed";
            case 9:
                return "Pending";
            case 10:
                return "Partially Refunded";
            case 11:
                return "Server Error";
            case 12:
                return "Offline";
            default:
                return "Unknown";
        }
    }
}
